import React, { memo } from "react";
import { Icon } from "@cld/icon";
import { KIND } from "../../data/consts";

const TYPE_ICONS = {
	[KIND.MY_DRIVE]: "googleDrive",
	[KIND.SHARED_WITH_ME]: "group",
	[KIND.SHARED_DRIVE]: "sharedDrive",
	[KIND.RECENT]: "recent",
	[KIND.STARRED]: "starred",
	[KIND.DRIVE]: "internalDrive",
};

const getIconName = (kind) => TYPE_ICONS[kind] || "folder";

const FolderIcon = ({ kind, variant }) => <Icon name={getIconName(kind)} variant={variant}/>;

export default memo(FolderIcon);
